"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.regexp.replace");
var _common = require("@/api/common");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: {
    fileStr: String,
    isClose: Boolean
  },
  data: function data() {
    return {
      flvUrl: 'https://sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/flv/xgplayer-demo-480p.flv',
      curOpenCoursId: this.$store.getters.curOpenCoursId,
      uploadFileList: [],
      file: '',
      fileObj: {},
      curType: "",
      srcList: [],
      photoList: [],
      imgUrl: '',
      officePreviewUrl: ''
    };
  },
  methods: {
    download: function download() {
      this.downloadIcveFile(this.fileObj.ossOriUrl, this.fileObj.fileName);
    },
    toPre: function toPre(file, fileUrl) {
      // console.log(file,fileUrl)
      if (file.toLowerCase().indexOf(".doc") != -1 || file.toLowerCase().indexOf(".docx") != -1 || file.toLowerCase().indexOf(".pptx") != -1 || file.toLowerCase().indexOf(".ppt") != -1 || file.toLowerCase().indexOf(".pdf") != -1 || file.toLowerCase().indexOf(".txt") != -1 || file.toLowerCase().indexOf(".rtf") != -1 || file.toLowerCase().indexOf(".xls") != -1 || file.toLowerCase().indexOf(".xlsx") != -1) {
        this.curType = "office";
      } else if (file.toLowerCase().indexOf(".png") != -1 || file.toLowerCase().indexOf(".jpeg") != -1 || file.toLowerCase().indexOf(".jpg") != -1 || file.toLowerCase().indexOf(".gif") != -1 || file.toLowerCase().indexOf(".bmp") != -1 || file.toLowerCase().indexOf(".tif") != -1 || file.toLowerCase().indexOf(".tiff") != -1) {
        this.curType = "pic";
        this.srcList.push(file);
      } else if (file.toLowerCase().indexOf(".mp4") != -1 || file.indexOf(".WebM") != -1 || file.toLowerCase().indexOf(".ogg") != -1) {
        this.curType = "video";
        this.getVideoBase64(file);
      } else if (file.toLowerCase().indexOf(".mp3") != -1 || file.toLowerCase().indexOf(".wav") != -1) {
        this.curType = "audio";
      } else if (file.toLowerCase().indexOf(".swf") != -1) {
        this.curType = "flash";
      } else if (file.toLowerCase().indexOf(".flv") != -1) {
        this.curType = "flv";
      }
      if (this.curType == "office") {
        this.getViewList(file, fileUrl);
      }
      // console.log('this.curType',this.curType)
      // console.log('file',file)
    },
    // 获取快照列表
    getViewList: function getViewList(file, i) {
      var _this = this;
      this.photoList = [];
      this.officePreviewUrl = '';
      (0, _common.getFileByUrl)({
        fileUrl: i
      }).then(function (res) {
        if (res && res.data && Array.isArray(res.data) && res.data.length > 0) {
          // 有快照数据，使用快照显示
          var v = res.data;
          var x = file.replace("file_doc", "file_gen_doc");
          v.forEach(function (item) {
            _this.photoList.push(x + "/" + item);
          });
        } else {
          // 无快照数据，使用 Office Online Viewer 在线预览
          // 使用 ossOriUrl 构建 Office Online 预览地址
          if (_this.fileObj.ossOriUrl) {
            var encodedUrl = encodeURIComponent(_this.fileObj.ossOriUrl);
            _this.officePreviewUrl = 'https://view.officeapps.live.com/op/view.aspx?src=' + encodedUrl;
          }
        }
      }).catch(function () {
        // 接口调用失败，使用 Office Online Viewer 作为备选
        if (_this.fileObj.ossOriUrl) {
          var encodedUrl = encodeURIComponent(_this.fileObj.ossOriUrl);
          _this.officePreviewUrl = 'https://view.officeapps.live.com/op/view.aspx?src=' + encodedUrl;
        }
      });
    },
    //设置video封面
    getVideoBase64: function getVideoBase64(url) {
      var _this2 = this;
      var dataURL = '';
      var video = document.createElement("video");
      video.setAttribute('crossOrigin', 'anonymous'); //处理跨域
      video.setAttribute('src', url);
      video.setAttribute('width', 1280);
      video.setAttribute('height', 736);
      video.currentTime = 2;
      video.addEventListener('loadeddata', function () {
        var canvas = document.createElement("canvas");
        var width = video.width; //canvas的尺寸和图片一样
        var height = video.height;
        canvas.width = width;
        canvas.height = height;
        canvas.getContext("2d").drawImage(video, 0, 0, width, height); //绘制canvas
        dataURL = canvas.toDataURL('image/jpeg'); //转换为base64
        _this2.imgUrl = dataURL;
        // console.log('this.imgUrl',this.imgUrl)
      });
    }
  },
  watch: {
    fileStr: {
      handler: function handler(e) {
        // console.log('fileStr',e)
        if (e) {
          this.fileObj = JSON.parse(e);
          if (this.fileObj.ossOriUrl) {
            this.toPre(this.fileObj.ossOriUrl, this.fileObj.url);
          }
        } else {
          if (this.curType == "video") {
            // console.log(this.$refs.preVideo,666)
            this.$refs.preVideo.pause();
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  created: function created() {}
};